"use strict";

module.exports = {
  indentation: require("./indentation"),
  "mustache-spacing": require("./mustache-spacing"),
  "partial-spacing": require("./partial-spacing"),
  "no-trailing-spaces": require("./no-trailing-spaces"),
  "eol-last": require("./eol-last"),
  "linebreak-style": require("./linebreak-style"),
  "no-invalid-bracket-path": require("./no-invalid-bracket-path"),
  "no-bare-builtin-block-helpers": require("./no-bare-builtin-block-helpers"),
};
